export default function rentTable() {
    const datePickUp = document.querySelector(".js-date-pick");
    const dateDropOff = document.querySelector(".js-date-drop");
    const rentPriceCells = document.querySelectorAll(".js-rent-price span[data-default]");
    const rentTimeCells = document.querySelectorAll(".js-rent-time");
    const rentResult = document.querySelector(".js-rent-result span[data-default]");
    const rentDaily = document.querySelector(".js-rent-daily span[data-default]");
    const rentTableWeek = document.querySelector(".js-rent-table-week");
    const rentTableMonth = document.querySelector(".js-rent-table-month");
    const rentResultSale = document.querySelector('.js-rent-result-sale span[data-default]');
    const rentSale = document.querySelector('.js-rent-sale');
    const rentCurrency = document.querySelector('.js-rent-result .js-currency');
    //const rentSale = document.querySelector('.js-rent-sale[data-sale]')?.dataset.sale;
    // if (rentTableWeek && rentPriceCells) {
    //   let week1 = rentPriceCells[1].innerHTML * 7;
    //   let week2 = rentPriceCells[2].innerHTML * 14;
    //   let week3 = rentPriceCells[2].innerHTML * 21;
    //   rentTableWeek.querySelectorAll('th')[0].innerHTML = week1;
    //   rentTableWeek.querySelectorAll('th')[1].innerHTML = week2;
    //   rentTableWeek.querySelectorAll('th')[2].innerHTML = week3;
    // }
    // if (rentTableMonth && rentPriceCells) {
    //   let month = rentPriceCells[3].innerHTML * 30;
    //   rentTableMonth.querySelector('th').innerHTML = month;
    // }
    if (
        navigator.vendor.indexOf("Apple") > -1 &&
        document.querySelectorAll(".car-page__aside-calendar")
    ) {
        for (let el of document.querySelectorAll(".car-page__aside-calendar")) {
            el.classList.add("car-page__aside-calendar_safari");
        }
    }

    function date_plus(x) {
        var today = new Date();
        return new Date(today.getTime() + x * 86400000);
    }

    function date_format(x) {
        let xDay = x.getDate();
        if (xDay < 10) {
            xDay = "0" + xDay;
        }
        let xMonth = x.getMonth() + 1;
        if (xMonth < 10) {
            xMonth = "0" + xMonth;
        }
        let xYear = x.getFullYear();
        return xYear + "-" + xMonth + "-" + xDay;
    }

    if (datePickUp) {
        datePickUp.value = date_format(date_plus(1));
        datePickUp.setAttribute("min", date_format(date_plus(0)));
    }
    if (dateDropOff) {
        dateDropOff.value = date_format(date_plus(2));
        dateDropOff.setAttribute("min", date_format(date_plus(2)));
    }

    function rentCalc() {
        console.log('calc',);
        if (rentPriceCells && rentResult) {
            let different =
                (new Date(dateDropOff.value).getTime() -
                    new Date(datePickUp.value).getTime()) /
                86400000;
            // different += 1;
            let result;
            /* if (different > rentTimeCells[0].dataset.time) {
              result = rentPriceCells[0].innerHTML * different;
              // rentDaily.innerHTML = rentPriceCells[0].innerHTML;
            }
            if (different > rentTimeCells[1].dataset.time) {
              result = rentPriceCells[1].innerHTML * different;
              // rentDaily.innerHTML = rentPriceCells[1].innerHTML;
            }
            if (different > rentTimeCells[2].dataset.time) {
              result = rentPriceCells[2].innerHTML * different;
              // rentDaily.innerHTML = rentPriceCells[2].innerHTML;
            }
            if (different > rentTimeCells[3].dataset.time) {
              result = rentPriceCells[3].innerHTML * different;
              // rentDaily.innerHTML = rentPriceCells[3].innerHTML;
            } */

            for (var z = 0; z < rentTimeCells.length; z++) {
                if (different > rentTimeCells[z].dataset.time) {
                    if (!isNaN(rentPriceCells[z].dataset.default)) {
                        result = rentPriceCells[z].dataset.default * different;
                        if (rentResultSale) {
                            rentResultSale.closest('.js-rent-result-sale').style.display = 'block';
                            rentResultSale.innerHTML = result.toLocaleString('ru-RU')
                            result = Math.round(result - (result * (rentResultSale.dataset.sale / 100)));
                        }
                        rentResult.innerHTML = result.toLocaleString(`${rentResult.dataset.lang}`);
                        if (rentSale) {
                            rentSale.style.display = 'block';
                        }
                        if (rentCurrency) {
                            rentCurrency.style.display = 'inline-block';
                        }
                    } else {
                        result = rentPriceCells[z].innerHTML;
                        rentResult.innerHTML = result;
                        if (rentResultSale) {
                            rentResultSale.closest('.js-rent-result-sale').style.display = 'none';
                        }
                        if (rentCurrency) {
                            rentCurrency.style.display = 'none';
                        }
                    }
                }
            }


            /*if (rentResultSale) {
              rentResultSale.innerHTML = result;
            }*/
        }
    }

    if (datePickUp && dateDropOff) {
        let start;
        let stop;
        datePickUp.addEventListener("change", function () {
            start = datePickUp.value;
            let startOffset = new Date(start).getTime() + 86400000;

            dateDropOff.setAttribute("min", date_format(new Date(startOffset)));
            if (new Date(dateDropOff.value).getTime() < new Date(start).getTime()) {
                dateDropOff.value = date_format(new Date(startOffset));
            }

            if (new Date(dateDropOff.value).getTime() > new Date(start).getTime()) {
                rentCalc();
            } else {
                rentResult.innerHTML = 0;
            }

        });

        dateDropOff.addEventListener("change", function () {
            console.log('change',);
            stop = dateDropOff.value;
            start = datePickUp.value;

            if (new Date(dateDropOff.value).getTime() > new Date(start).getTime()) {
                rentCalc();
            } else {
                rentResult.innerHTML = 0;
            }

        });

        dateDropOff.addEventListener("blur", function () {
            setTimeout(() => {
                stop = dateDropOff.value;
                let startOffset = new Date(start).getTime() + 86400000;
                dateDropOff.setAttribute("min", date_format(new Date(startOffset)));
                if (new Date(dateDropOff.value).getTime() <= new Date(start).getTime()) {
                    dateDropOff.value = date_format(new Date(startOffset));
                    rentCalc();
                }
            }, 500);
        });


    }
}



